export default "__VITE_ASSET__162f283e__"